const CONTENT_TYPE_MAP = {
  string: 'Text',
};
export default CONTENT_TYPE_MAP;



// WEBPACK FOOTER //
// ./src/contentTypeMap.js